function setVapidKeysAsReloaded(vapid_key_data) {
  // rather than a timestamp we should have a version number
  const data = {...vapid_key_data, timestamp: new Date().getTime()};
  localStorage.setItem("reloaded-vapid-keys", JSON.stringify(data))
}
// don't compare w/ server keys for now
function shouldReloadVapidKeys() {
  return localStorage.getItem("reloaded-vapid-keys") == null;
}

function fetchVapidPublicKey() {
  return new Promise((resolve, reject) => {
    fetch("/api/v1/notification/vapid_public_key", {
      method: "get",
      redirect: "error",
      headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json'
      }
    }).then((response) => {
        // should redirect
        if (response.status === 200) {
          response.json().then(data => { resolve(data) })
        } else {
          reject({ error: {type: "http", value: response.status} })
        }
    }).catch((error) => {
      if (error.message.startsWith("Not allowed to follow a redirection")) {
        reject({ error: { type: "loggedout", value: null } });
      } else {
        reject({ error: {type: "unknown", value: error } });
      }
    })
  })
}


export function ensureNotificationPermission() {
  if (Notification.permission == "granted") {
    return Promise.resolve("granted");
  } else {
    return Notification.requestPermission();
  }
}

function registerSubscriptionOnServer(subscription, mode) {
  console.log("pushManager subscribed", subscription)

  fetch(`/api/v1/notification/register?mode=${mode}`, {
      method: "POST",
      headers: {'Content-Type': 'application/json'},
      body: JSON.stringify({ subscription  })
  })
}

// called when app render the main stack and when the service worker reloads
export function ensureSubscribe(registration) {
  registration.pushManager.getSubscription().then(subscription => {
    if (subscription) {
      if (shouldReloadVapidKeys()) {
	return unsubscribe(registration).then(() => {
	  return subscribe(registration);
	})
      } else {
	console.log("[push] already subscribed", subscription);
	registerSubscriptionOnServer(subscription, "update");
	return subscription;
      }
    } else {
      // first try to get notification permission
      // only if user has user enabled that we continue
      // this way we "memorize" its choice if he had blocked before subscription/notification
      return ensureNotificationPermission().then((permission) => {
	console.log("[notification permission]", permission);

	if (permission == "granted") {
	  return subscribe(registration);
	} else {
	  return s;
	}
      })
    }
  })
}

export function subscribe(registration) {
  console.log("subscribing to registration: ", registration);

  return fetchVapidPublicKey().then((vapid_key_data) => {
    return registration.pushManager.subscribe({ userVisibleOnly: true, ...vapid_key_data })
      .then((subscription) => {
	setVapidKeysAsReloaded(vapid_key_data)

	return registerSubscriptionOnServer(subscription, "new")
	// document.getElementById("confirm-modal").checked = true
      }).catch((error) => alert(error.message))
  }).catch((err) => {
    console.log("[sw] fetchVapidPublicKey error: ", err);
  })
}

export function unsubscribe(registration) {
  return registration.pushManager.getSubscription().then((subscription) => {
    return subscription.unsubscribe().then(() => {
      return fetch("/api/v1/notification/unregister", {
	  method: "POST",
	  headers: {'Content-Type': 'application/json'},
	  body: JSON.stringify({subscription})
      })
    })
  })
}
